// extracted by mini-css-extract-plugin
export default {"container":"CTA_container__1dDNK","title":"CTA_title__zARVe","accent":"CTA_accent__koHTx","description":"CTA_description__Shrpd"};